import { zendeskHttpRequest } from "../zendeskHttpRequest.ts";
import { IArticleAttachment } from "../../../models/articleAttachment.ts";

export const getArticleAttachments = async (
  token: string,
  brandUrl: string,
  articleId: number,
): Promise<IArticleAttachment[]> => {
  const data = await zendeskHttpRequest<{
    article_attachments: IArticleAttachment[];
  }>(`help_center/articles/${articleId}/attachments`, token, "GET", brandUrl);
  return data.article_attachments;
};
